import React from "react";

export const CardGridContext = React.createContext({
  cardWidth: 250,
  cardHeight: 350,
});
